// extracted by mini-css-extract-plugin
export default {"employee":"Employee_employee__QIkKD","line":"Employee_line__CXcBa","img":"Employee_img__TT+rx","name":"Employee_name__W9xW4","nameContainer":"Employee_nameContainer__xxlgl"};